import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { SearchSharedModule } from '@search/shared/search-shared.module';
import { FacetValueListComponent } from '../components/search-filters/facet-value-list/facet-value-list.component';
import { NewSearchFiltersBaseComponent } from '../components/search-filters/new-search-filters-base.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewSearchResultComponent } from '../components/new-search-result/new-search-result.component';
import { NewSearchFilteringComponent } from '../components/search-filters/new-search-filtering/new-search-filtering.component';
import { FacetValuePanelComponent } from '../components/search-filters/new-search-filtering/facet-value-panel/facet-value-panel.component';
import { SelectedFacetValuesComponent } from '../components/search-filters/new-search-filtering/selected-facet-values/selected-facet-values.component';
import { NewSearchFiltersMobileComponent } from '../components/search-filters/new-search-filters-mobile/new-search-filters-mobile.component';
import { NewSearchFiltersTabletComponent } from '../components/search-filters/new-search-filters-tablet/new-search-filters-tablet.component';
import { IonicModule } from '@ionic/angular';
import { NewSearchActionsComponent } from '../components/new-search-actions/new-search-actions.component';
import { FacetFlyoutContainerComponent } from '../components/facet-flyout-container/facet-flyout-container.component';
import { NewSearchSkeletonComponent } from '../components/new-search-skeleton/new-search-skeleton.component';
import { NewSearchFacetSkeletonComponent } from '../components/new-search-facet-skeleton/new-search-facet-skeleton.component';
import { NewSearchFacetPillsComponent } from '../components/new-search-facet-pills/new-search-facet-pills.component';
import { NewSearchOperationsComponent } from '../components/new-search-operations/new-search-operations.component';
import { NewSearchBarComponent } from '../components/new-search-bar/new-search-bar.component';
import { SearchTopButtonComponent } from '../components/search-top-button/search-top-button.component';
import { StickyActionBarComponent } from '../components/sticky-action-bar/sticky-action-bar.component';
import { MobileSearchOperationsComponent } from '../components/mobile-search-operations/mobile-search-operations.component';
import { SharedProductModule } from '@app/shared-product/shared-product.module';
import { RegularFacetComponent } from '@app/new-search/components/facet-flyout-container/regular-facet/regular-facet.component';
import { CategoryFacetComponent } from '@app/new-search/components/facet-flyout-container/category-facet/category-facet.component';
import { ListFacetComponent } from '@app/new-search/components/facet-flyout-container/list-facet/list-facet.component';
import { SearchBarFacetComponent } from '@app/new-search/components/facet-flyout-container/search-bar-facet/search-bar-facet.component';

@NgModule({
  declarations: [
    NewSearchResultComponent,
    NewSearchFiltersBaseComponent,
    NewSearchFilteringComponent,
    FacetValuePanelComponent,
    SelectedFacetValuesComponent,
    NewSearchFiltersMobileComponent,
    NewSearchFiltersTabletComponent,
    FacetValueListComponent,
    NewSearchActionsComponent,
    FacetFlyoutContainerComponent,
    NewSearchSkeletonComponent,
    NewSearchFacetSkeletonComponent,
    NewSearchFacetPillsComponent,
    NewSearchOperationsComponent,
    NewSearchBarComponent,
    SearchTopButtonComponent,
    StickyActionBarComponent,
    MobileSearchOperationsComponent,
    RegularFacetComponent,
    CategoryFacetComponent,
    ListFacetComponent,
    SearchBarFacetComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SearchSharedModule,
    ReactiveFormsModule,
    SharedProductModule,
  ],
  exports: [
    NewSearchResultComponent,
    NewSearchFiltersBaseComponent,
    NewSearchFilteringComponent,
    FacetValuePanelComponent,
    SelectedFacetValuesComponent,
    NewSearchFiltersMobileComponent,
    NewSearchFiltersTabletComponent,
    FacetValueListComponent,
    NewSearchActionsComponent,
    FacetFlyoutContainerComponent,
    NewSearchSkeletonComponent,
    NewSearchFacetSkeletonComponent,
    NewSearchFacetPillsComponent,
    NewSearchOperationsComponent,
    NewSearchBarComponent,
    SearchTopButtonComponent,
    StickyActionBarComponent,
    MobileSearchOperationsComponent,
  ],
})
export class NewSearchBaseModule {}
